import * as THREE from 'three';
import { physicsWorld, getRapier } from './physics.js';
import { config } from './config.js';
import { rigidBodies } from './objects-shared.js';

export function createCylinders(scene) {
    const cylinders = [
        { p: [0, 15, -50], r: 20, h: 10, c: 0x111111 },
        { p: [80, 35, -140], r: 13, h: 40, c: 0x000000 },
        { p: [-160, 50, -50], r: 13, h: 50, c: 0xBAEAEE }
    ];

    const RAPIER = getRapier();
    cylinders.forEach(cyl => {
        const mesh = new THREE.Mesh(
            new THREE.CylinderGeometry(cyl.r, cyl.r, cyl.h, 32),
            new THREE.MeshStandardMaterial({ 
                color: 0x444456, 
                metalness: 0.3, 
                roughness: 0.8, 
                emissive: cyl.c, 
                emissiveIntensity: 0.2, 
                
            })
        );
        mesh.position.set(cyl.p[0], cyl.p[1], cyl.p[2]);
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        scene.add(mesh);

        const body = physicsWorld.createRigidBody(
            RAPIER.RigidBodyDesc.dynamic()
                .setTranslation(cyl.p[0], cyl.p[1], cyl.p[2])
                .setLinearDamping(0.5)
                .setAngularDamping(0.8)
        );
        const col = RAPIER.ColliderDesc.cylinder(cyl.h / 2, cyl.r)
            .setRestitution(config.physics.cylinderRestitution)
            .setFriction(config.physics.cylinderFriction)
            .setDensity(1.0);
        physicsWorld.createCollider(col, body);
body.userData = {
    type: 'cylinder',
    meshReference: mesh
};
        mesh.userData.physicsBody = body;
        mesh.userData.isCylinder = true;
        rigidBodies.push(mesh);
    });
}